import * as tealium from './tealium';
import * as number from './number';
import * as price from './price';

/* eslint import/no-webpack-loader-syntax: off */
// Expose TealiumHelper globally for compatibility for calls from not bundled code
// Or tealium extensions which use it
require('expose-loader?TealiumHelper!./tealium');

export {
  tealium,
  number,
  price,
};
